import React from "react";

export default function useLoadImageViaIpfs() {
  return React.useCallback(async (url: string) => {
    if (typeof window === "undefined") {
      throw new Error("IPFS image loading is not supported on the server");
    }

    const { verifiedFetch } = await import("@helia/verified-fetch");
    const response = await verifiedFetch(url);

    if (response.status !== 200) {
      throw new Error("Failed to load image");
    }

    const blob = await response.blob();
    const src = URL.createObjectURL(blob);
    return src;
  }, []);
}
